import { render, staticRenderFns } from "./endSortingModal.vue?vue&type=template&id=4426a486&scoped=true"
import script from "./endSortingModal.vue?vue&type=script&lang=js"
export * from "./endSortingModal.vue?vue&type=script&lang=js"
import style0 from "./endSortingModal.vue?vue&type=style&index=0&id=4426a486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4426a486",
  null
  
)

export default component.exports